import { render, staticRenderFns } from "./ChannelsFormComponent.vue?vue&type=template&id=e1e61cf6&scoped=true&"
import script from "./ChannelsFormComponent.vue?vue&type=script&lang=js&"
export * from "./ChannelsFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChannelsFormComponent.vue?vue&type=style&index=0&id=e1e61cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e61cf6",
  null
  
)

export default component.exports